import { useRef, useState } from 'react';
import { Button } from '@mui/material';
import RefreshRounded from '@mui/icons-material/RefreshRounded';
import { useNotifications } from '@toolpad/core';
import { getApiErrorMessage } from '../utils/apiErrorUtils';

interface RefreshButtonProps {
    onRefresh: () => void | Promise<unknown>;
    loading?: boolean;
    disabled?: boolean;
    ariaLabel?: string;
}

export default function RefreshButton({ onRefresh, loading = false, disabled = false, ariaLabel = 'Refresh' }: RefreshButtonProps) {
    const notifications = useNotifications();
    const [pending, setPending] = useState(false);
    const inFlight = useRef(false);

    const refresh = async () => {
        if (inFlight.current || loading || disabled) return;
        inFlight.current = true;
        setPending(true);
        try {
            await onRefresh();
        } catch (error) {
            notifications.show(getApiErrorMessage(error, 'We could not refresh your data. Try again.'), {
                severity: 'error', autoHideDuration: 3000,
            });
        } finally {
            inFlight.current = false;
            setPending(false);
        }
    };

    return (
        <Button variant="text" size="small" startIcon={<RefreshRounded />} aria-label={ariaLabel}
            loading={loading || pending} disabled={disabled} onClick={() => void refresh()}>
            Refresh
        </Button>
    );
}
